import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FaFilePdf } from 'react-icons/fa'
import { Box, Heading } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const DownloadLink = styled.a`
    display: inline-flex;
    align-items: center;
    padding: 10px 20px;
    margin: 10px 0;
    color: #ff0000;
    border: 1px solid #ff0000; // Adobe Red color
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    border-radius: 4px;

    &:hover {
        background-color: #ff0000;
        color: #fff;
    }
`

const PdfLink = (props) => {
    const { t } = useTranslation()

    return (
        <Box mt={10}>
            <Heading as={'h2'} fontSize={'3xl'}>
                {t('attached-files')}
            </Heading>
            <DownloadLink href={props.pdfUrl} target="_blank" rel="noopener noreferrer">
                <FaFilePdf size={'30'} /> &nbsp; {props.children}
            </DownloadLink>
        </Box>
    )
}

PdfLink.propTypes = {
    pdfUrl: PropTypes.string.isRequired,
}

export default PdfLink
